import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addLeadfeedbacktype,
  getLeadfeedbacktypes,
  getLeadfeedbacktype,
  editLeadfeedbacktype,
  deleteLeadfeedbacktype,
  getAllLeadfeedbacktypes,
} from "../../store/actions/leadfeedbacktype_action";
import { SEARCH_TERMS } from "../enums/leadfeedbacktypes_enum";
// Get All Data
export const useAllLeadfeedbacktypes = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.leadfeedbacktype);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await dispatch(deleteLeadfeedbacktype(deleteEntry));
      }
      if (term && term.length > 0) {
        setQ(term);
        dispatch(
          getLeadfeedbacktypes({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      } else {
        dispatch(
          getLeadfeedbacktypes({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      }
    }
    allQuery();
  }, [deleteEntry, term, pageNumber, dateFrom, dateTo]);
  useEffect(() => {
    setPageNumber(1);
  }, [term, dateTo, dateFrom]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPageNumber(1);
    setQ(null);
    setTerm("");
    setDateFrom("");
    setDateTo("");
    dispatch(getLeadfeedbacktypes({}));
  };

  return [
    data,
    pageNumber,
    setPageNumber,
    q,
    term,
    setTerm,
    termField,
    setTermField,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    deleteBtnClicked,
    resetFilter,
  ];
};

// Get Single Data
export const useSingleLeadfeedbacktype = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.leadfeedbacktype);
  useEffect(() => {
    dispatch(getLeadfeedbacktype(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateLeadfeedbacktype = () => {
  const dispatch = useDispatch();
  const addData = async (data) => {
    await dispatch(addLeadfeedbacktype(data));
  };
  return [addData];
};
export const useUpdateLeadfeedbacktype = () => {
  const dispatch = useDispatch();
  const updateData = async (id, data) => {
    await dispatch(editLeadfeedbacktype(id, data));
  };
  return [updateData];
};

export const useSelectAllLeadfeedbacktype = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.leadfeedbacktype);
    useEffect(() => {
      dispatch(getAllLeadfeedbacktypes());
    }, []);
    return [data];
  };        